import React from 'react'

import './Testimonials.css';

function Testimonials() {
    return (
        <div className="testimonials">
            
        </div>
    )
}

export default Testimonials
